module.exports = __webpack_public_path__ + "img/account.a20c9383.svg";